(() => {
  const tag = 'fs-pdp-interactions';
  if (!window.customElements || customElements.get(tag)) return;
  customElements.define(tag, class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info[data-fs-product-page]');
      if (!this.root || this.controller) return;
      this.controller = new AbortController();
      const options = { capture: true, signal: this.controller.signal };
      this.required = this.dataset.requiresSize === 'true';
      const requested = new URL(window.location.href).searchParams.get('variant');
      this.confirmed = !this.required || Boolean(requested && requested === this.dataset.initialVariant);
      this.apply();
      this.root.addEventListener('submit', event => {
        if (event.target.matches('product-form form[data-type="add-to-cart-form"]') && this.owns(event.target) && !this.confirmed) {
          this.stop(event);
          this.prompt();
        }
      }, options);
      this.root.addEventListener('click', event => this.onClick(event), options);
      this.root.addEventListener('change', event => {
        const target = event.target;
        if (this.owns(target) && target.matches('select, input[type="radio"]') && target.closest('[data-fs-size-field]') && !target.disabled) this.confirm();
      }, options);
      this.root.addEventListener('keydown', event => {
        if (event.key === ' ' && event.target.matches('input[type="radio"]') && event.target.closest('[data-fs-size-field]') && this.owns(event.target) && !event.target.disabled) this.confirm();
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
    owns(element) {
      return element instanceof Element && element.closest('product-info') === this.root;
    }
    stop(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    onClick(event) {
      const target = event.target;
      if (!this.owns(target)) return;
      const field = target.closest('[data-fs-size-field]');
      if (field) {
        let input = target.closest('input[type="radio"]');
        const label = target.closest('label');
        if (!input && label?.htmlFor) input = field.querySelector(`#${CSS.escape(label.htmlFor)}`);
        if (input && !input.disabled) this.confirm();
      }
      if (this.confirmed) return;
      const action = target.closest('product-form button[type="submit"], product-form .shopify-payment-button');
      if (action && !action.disabled && action.getAttribute('aria-disabled') !== 'true') {
        this.stop(event);
        this.prompt();
      }
    }
    confirm() {
      this.confirmed = true;
      this.apply();
    }
    apply() {
      this.root.setAttribute('data-fs-size-confirmed', String(this.confirmed));
      if (this.confirmed) {
        this.root.removeAttribute('data-fs-size-prompt');
        const message = this.querySelector('[data-fs-size-message]');
        if (message) message.hidden = true;
        this.root.querySelectorAll('[data-fs-size-field]').forEach(field => {
          const ids = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(id => id && id !== message?.id);
          if (ids.length) field.setAttribute('aria-describedby', ids.join(' '));
          else field.removeAttribute('aria-describedby');
        });
      }
    }
    prompt() {
      const field = this.root.querySelector('variant-selects [data-fs-size-field]');
      if (!field) return;
      this.root.setAttribute('data-fs-size-prompt', 'true');
      const message = this.querySelector('[data-fs-size-message]');
      if (message) {
        if (!message.id) message.id = `${this.root.id}-choose-size`;
        message.textContent = this.dataset.chooseSize || '';
        message.hidden = false;
        const ids = new Set((field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
        ids.add(message.id);
        field.setAttribute('aria-describedby', [...ids].join(' '));
      }
      field.scrollIntoView({ block: 'center', behavior: 'auto' });
      const control = field.querySelector('input[type="radio"]:checked:not(:disabled), select:not(:disabled), input[type="radio"]:not(:disabled)');
      if (control) control.focus({ preventScroll: true });
      else {
        field.tabIndex = -1;
        field.focus({ preventScroll: true });
      }
    }
  });
})();
